import { render, staticRenderFns } from "./allot-role.vue?vue&type=template&id=7b6dffba&scoped=true"
import script from "./allot-role.vue?vue&type=script&lang=ts"
export * from "./allot-role.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6dffba",
  null
  
)

export default component.exports